import { render, staticRenderFns } from "./Quasar.vue?vue&type=template&id=3400868c&scoped=true&"
import script from "./Quasar.vue?vue&type=script&lang=js&"
export * from "./Quasar.vue?vue&type=script&lang=js&"
import style0 from "./Quasar.vue?vue&type=style&index=0&id=3400868c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3400868c",
  null
  
)

export default component.exports